var _span;
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OPTIONAL = '(optional)';

/**
 *  FormElementLabel renders a label to a form element, such as Input, Checkbox, etc
 *
 */
function FormElementLabel(_ref) {
  let {
    fakeLabel = false,
    label,
    optional = false,
    layout,
    ...rest
  } = _ref;
  if (!label) {
    return null;
  }
  let optionalLabel = null;
  if (optional && layout !== 'inside') {
    optionalLabel = /*#__PURE__*/_jsxs("span", {
      children: [label, _span || (_span = /*#__PURE__*/_jsx("span", {
        className: "text-size-200 text-normal supporting-label margin-left-1",
        children: OPTIONAL
      }))]
    });
  } else if (optional) {
    optionalLabel = `${label} ${OPTIONAL}`;
  }
  const LabelNode = fakeLabel ? 'div' : 'label';
  return /*#__PURE__*/_jsx(LabelNode, {
    "data-cmp": "form-element-label",
    ...rest,
    children: optional ? optionalLabel : label
  }, "form-element-label");
}
export default FormElementLabel;